module.exports = __webpack_public_path__ + "img/bsjg_06.37cd56ec.png";